import { render, staticRenderFns } from "./ChatwootTeste.vue?vue&type=template&id=409d0571&scoped=true&"
import script from "./ChatwootTeste.vue?vue&type=script&lang=js&"
export * from "./ChatwootTeste.vue?vue&type=script&lang=js&"
import style0 from "./ChatwootTeste.vue?vue&type=style&index=0&id=409d0571&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d0571",
  null
  
)

export default component.exports